<div class="ds-feedback-loop">
  <ng-container [ngSwitch]="activeStep">
    <ng-container *ngSwitchCase="feedbackSteps.INIT">
      <h3 class="ds-heading-3"><ng-content></ng-content></h3>

      <div class="ds-feedback-actions">
        <button type="button" class="ds-feedback-button" (click)="onFeedback(true)">
          <ion-icon name="ds-thumbs-up"></ion-icon>
          <span class="ds-ui-2">{{'feedbackLoopWidget.buttonPositive.label' | translate}}</span>
        </button>

        <button type="button" class="ds-feedback-button" (click)="onFeedback(false)">
          <ion-icon name="ds-thumbs-down"></ion-icon>
          <span class="ds-ui-2">{{'feedbackLoopWidget.buttonNegative.label' | translate}}</span>
        </button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="feedbackSteps.FINISH">
      <ion-icon name="ds-message-circle" class="ds-feedback-icon"></ion-icon>
      <h3 class="ds-heading-3">{{'feedbackLoopWidget.successMessage' | translate}}</h3>
    </ng-container>
  </ng-container>
  <p
    class="ds-ui-3 ds-color-core-neutral-8 ds-feedback-link"
    *ngIf="showLink"
    [innerHTML]="'balanceSheet.dataRequestDescription' | translate"
  ></p>
</div>
